import { Banner, Field, Input, Switch } from '@cloudflare/kumo';

export interface AvatarFields {
  videoAvatar: { provider: 'talkinghead' | 'self-hosted'; modelUrl: string; maxSessionSeconds: number; maxSessionsPerIpPerDay: number } | null;
  voice: { tts: boolean } | null;
}
const DEFAULT = { provider: 'talkinghead' as const, modelUrl: '', maxSessionSeconds: 120, maxSessionsPerIpPerDay: 5 };

/** Aba Avatar do editor: personagem 3D (TalkingHead) que fala com a voz do agente */
export function AgentAvatarFields({ value, readOnly, onChange }: { value: AvatarFields; readOnly?: boolean; onChange: (patch: Pick<AvatarFields, 'videoAvatar'>) => void }) {
  const a = value.videoAvatar;
  const hasVoice = !!value.voice?.tts;
  const set = (patch: Partial<NonNullable<AvatarFields['videoAvatar']>>) => onChange({ videoAvatar: { ...(a ?? DEFAULT), ...patch } });
  return (
    <div className="space-y-4">
      <p className="text-sm text-kumo-subtle">
        O avatar é um personagem 3D que aparece no widget e mexe a boca no ritmo da voz do agente. Roda no navegador do visitante, sem custo por minuto.
      </p>
      {!hasVoice && <Banner variant="default" description={<>Ligue o botão <b>Ouvir</b> na aba Voz: o avatar fala com a voz do agente.</>} />}
      <Switch checked={!!a} disabled={readOnly || !hasVoice} onCheckedChange={(checked: boolean) => onChange({ videoAvatar: checked ? { ...DEFAULT } : null })} label="Mostrar avatar no widget" />
      {a && (
        <>
          <Field label="Modelo 3D (GLB)" description="Endereço https de um avatar GLB com blendshapes ARKit e visemas (Avaturn, Blender ou similar).">
            <Input value={a.modelUrl} disabled={readOnly} placeholder="https://…/avatar.glb" onChange={(e) => set({ modelUrl: e.target.value })} />
          </Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Duração máxima da sessão (s)" description="De 30 a 3600.">
              <Input type="number" inputMode="numeric" disabled={readOnly} value={String(a.maxSessionSeconds)} onChange={(e) => set({ maxSessionSeconds: Number(e.target.value) || 120 })} />
            </Field>
            <Field label="Sessões por visitante por dia" description="Limite por IP, de 1 a 100.">
              <Input type="number" inputMode="numeric" disabled={readOnly} value={String(a.maxSessionsPerIpPerDay)} onChange={(e) => set({ maxSessionsPerIpPerDay: Number(e.target.value) || 5 })} />
            </Field>
          </div>
        </>
      )}
    </div>
  );
}
